import { Flex } from "@chakra-ui/react";
import { get } from "lodash";
import { PropsWithChildren } from "react";
import { useTracking } from "~/lib/hooks";
import { LayoutOptions } from "~/types";
import { Footer } from "./Footer/Footer";
import { Header } from "./NavHeader/Header";

export const Layout = ({
  children,
  layoutOptions,
}: PropsWithChildren<{
  layoutOptions?: LayoutOptions;
}>) => {
  useTracking();
  const showFooter = get(layoutOptions, "showFooter", true);
  const showHeader = get(layoutOptions, "showHeader", true);
  const backgroundColor = get(layoutOptions, "backgroundColor", "white");
  return (
    <>
      {showHeader && <Header />}
      <Flex direction="column" bg={backgroundColor}>{children}</Flex>
      {showFooter && <Footer backgroundColor={backgroundColor} />}
    </>
  );
};
